import React from 'react';
import { withRouter } from 'react-router-dom';
import { abortRequestsForOtherRoutes } from '../services/navigationAbort';

// Renders nothing. Watches the router and, whenever the pathname changes,
// cancels the requests still in flight for the page we just left (see
// services/navigationAbort). Query-string changes — paging, filters — are not
// navigation and are deliberately ignored.
//
// This runs after the incoming page's componentDidMount, but that is harmless:
// the new page's requests are tagged with the new pathname, so only the
// outgoing page's requests are in the cancel set.
class NavigationAbort extends React.Component {
  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location;
    if (prevProps.location.pathname !== pathname) {
      abortRequestsForOtherRoutes(pathname);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(NavigationAbort);
